export default "__VITE_ASSET__D9ev1LVM__"